import { render, staticRenderFns } from "./ProductPicker.vue?vue&type=template&id=50eda576&scoped=true&"
import script from "./ProductPicker.vue?vue&type=script&lang=js&"
export * from "./ProductPicker.vue?vue&type=script&lang=js&"
import style0 from "./ProductPicker.vue?vue&type=style&index=0&id=50eda576&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50eda576",
  null
  
)

export default component.exports